import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import account from '@/common/account/index';

const OcrHrDemonstration = ({ materialsPath, selectList }) => {
  const [result, setResult] = useState([]);
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      picture: '图片的Base64编码',
      url: '图像地址'
    }
  });

  const identifyingImg = (imgUrl, picture) => {
    let imgBase64 = '';
    if (picture) {
      imgBase64 = picture.replace(/\S*base64,/, '');
    }
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    fetchOCR({
      image_url: imgUrl,
      image_base64: imgBase64,
      method: '/aiimage/handrecognition',
      userId
    })
      .then((data) => {
        setReponse(data);
        if (data.code === 20000) {
          const res = data.data.line_results;
          setResult(res || []);
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
      });
  };

  return (
    <FunctionDemonstration
      result={
        <ul>
          {result.map((resultItem, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li key={resultItem.texts + index} className="result_text">
                <span>{index + 1}</span>
                <span>{resultItem.texts}</span>
              </li>
            );
          })}
        </ul>
      }
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
      selectList={selectList}
    />
  );
};

OcrHrDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array
  })
};

export default OcrHrDemonstration;
